module.exports = __webpack_public_path__ + "img/Group 13.968e070b.png";